import { Link } from "@tanstack/react-router";

export function InvestorDisclaimer() {
  return (
    <section className="relative py-20 bg-background border-y border-border">
      <div className="mx-auto max-w-4xl px-6">
        {/* Section Heading */}
        <h2 className="font-display text-3xl sm:text-4xl text-center mb-12 tracking-tight">
          Investor Information & Important Disclaimer
        </h2>

        {/* Body Copy */}
        <div className="space-y-5 text-sm leading-relaxed text-muted-foreground">
          <p>
            The information presented on this website is provided solely for informational purposes regarding ClutchCube and its business vision.
          </p>
          <p>
            Nothing contained on this website, including any investor presentation, financial projections, business plans, or other materials, constitutes an offer to sell or a solicitation of an offer to buy any securities.
          </p>
          <p>
            Any investment opportunity involving ClutchCube will be made only through definitive offering documents, if and when available, and only in compliance with applicable federal and state securities laws.
          </p>
          <p>
            Access to the ClutchCube investor presentation is intended solely for individuals and organizations interested in learning more about the company. Submission of an investor information request does not qualify any individual as an investor, nor does it create any obligation on the part of ClutchCube to provide investment opportunities or additional materials.
          </p>
          <p>
            Certain information contained within investor materials may include forward-looking statements, estimates, projections, and expectations regarding future business performance. These statements are based on current assumptions and are subject to significant risks, uncertainties, and changes in market conditions. Actual results may differ materially from those expressed or implied.
          </p>
          <p>
            Investment in an early-stage company involves substantial risk, including the possible loss of the entire investment. Prospective investors should conduct their own independent due diligence and consult with their legal, tax, accounting, and financial advisors before making any investment decision.
          </p>
          <p>
            ClutchCube reserves the right to determine, in its sole discretion, whether to provide additional information, continue discussions, or accept investment from any prospective investor.
          </p>
        </div>

        {/* Qualified Investors Callout */}
        <div className="mt-12 bg-card border border-primary/30 rounded-sm p-8 sm:p-10 shadow-elevated">
          <h3 className="font-display text-xl sm:text-2xl mb-5 text-foreground">
            Qualified Investors
          </h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            Investor materials are intended for individuals, family offices, venture capital firms, private equity firms, strategic corporate investors, franchise development groups, and other prospective investors who are evaluating potential investment opportunities. ClutchCube may request additional information to determine whether a prospective investor is appropriate for further discussions.
          </p>
        </div>

        {/* Footer Links */}
        <div className="mt-12 flex flex-wrap justify-center gap-x-6 gap-y-2 text-[11px] uppercase tracking-[0.25em] text-muted-foreground">
          <Link to="/privacy" className="hover:text-foreground transition">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-foreground transition">Terms of Use</Link>
        </div>
      </div>
    </section>
  );
}
